module.exports = __webpack_public_path__ + "assets/images/JMDBOX1.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/JMDBOX1.png
// module id = 1394
// module chunks = 1